import React from 'react';
import PropTypes from 'prop-types';

import TrainingFAQItem from 'components/TrainingFAQItem';

const FAQSection = ({ faqList }) => {
  return (
    <section className="training-faq-main">
      <div className="container">
        <h2 className="big-heading">FAQs</h2>
        <div className="faq-block">
          {faqList.map((faq) => (
            <TrainingFAQItem question={faq.question} answer={faq.answer} />
          ))}
        </div>
      </div>
    </section>
  );
};

FAQSection.propTypes = {
  faqList: PropTypes.array,
};

export default FAQSection;
